// TODO: i18n Удалить после изменения английского в Contentful c en-us на просто us
import type { RouterLocale } from '~i18n/constants';

export const defaultContentfulLocale = 'en-US';
export const contentfulLocales = [defaultContentfulLocale /*, 'de'*/] as const;

export type ContentfulLocale = (typeof contentfulLocales)[number];

const routerToContentful: Record<RouterLocale, ContentfulLocale> = {
	en: defaultContentfulLocale,
	// TODO: i18n Раскомментировать чтобы включить немецкий в роутинге
	// de: 'de',
};

const contentfulToRouter: Record<ContentfulLocale, RouterLocale> = {
	[defaultContentfulLocale]: 'en',
	// TODO: i18n Раскомментировать чтобы включить немецкий в роутинге
	// de: 'de',
};

// 'en' -> en-US'
export const getContentfulLocale = (iso2: RouterLocale) =>
	routerToContentful[iso2];

// en-US' -> 'en'
export const getRouterLocale = (contentful: ContentfulLocale): RouterLocale =>
	contentfulToRouter[contentful];
